import React from "react";
import Flex from "Components/Flex.js";
import String from "Components/String.js";

export default props => (
	<Flex justifySelf="center">
		<String color="textSecondary" str={(props.message || "Nothing to show.")} />
	</Flex>
);
